export const APARTMENT_TYPES = ['Lägenhet', 'Bostad flerfamiljshus'];
